export default __webpack_public_path__ + "static/media/reporting.8672a60f.svg";